import { useTranslation } from 'react-i18next';
import { Helmet } from 'react-helmet-async';
import { Box, Divider, Stack, Typography } from '@mui/material';

import {
  BackToHome,
  GlassCard,
  PublicContainer,
  PublicPage,
  PublicPageHero,
  publicPalette,
} from '../../Public/PublicLayout';

const TermsConditions = () => {
  const { t } = useTranslation();
  const sections = [
    ['terms_and_conditions.terms_of_use', 'terms_and_conditions.terms_of_use_rules'],
    ['terms_and_conditions.price_and_payment', 'terms_and_conditions.price_and_payment_rules'],
    ['terms_and_conditions.our_responsability', 'terms_and_conditions.our_responsability_rules'],
    ['terms_and_conditions.links', 'terms_and_conditions.links_rules'],
    ['terms_and_conditions.promo_and_advertising', 'terms_and_conditions.promo_and_advertising_rules'],
    ['terms_and_conditions.final_considerations', 'terms_and_conditions.final_considerations_rules'],
    ['terms_and_conditions.privacy_policy', 'terms_and_conditions.privacy_policy_rules'],
  ];

  return (
    <PublicPage>
      <Helmet>
        <title>CONTDEPLATA — {t('terms_and_conditions.terms_and_conditions')}</title>
        <meta name="description" content={t('public.terms_meta', { defaultValue: 'Terms of use, payment conditions, responsibilities, links, promotions, and privacy information for CONTDEPLATA.MD.' })} />
      </Helmet>

      <PublicPageHero
        eyebrow={t('public.legal', { defaultValue: 'Legal' })}
        title={t('terms_and_conditions.terms_and_conditions')}
        description={t('public.terms_intro', { defaultValue: 'The rules governing access to and use of CONTDEPLATA.MD, presented in a clearer, easier-to-read format.' })}
        actions={<BackToHome />}
        compact
      />

      <Box sx={{ py: { xs: 7, md: 11 }, backgroundColor: publicPalette.background }}>
        <PublicContainer sx={{ maxWidth: 1040 }}>
          <GlassCard sx={{ p: { xs: 3, sm: 5, md: 6 } }}>
            <Typography sx={{ color: publicPalette.muted, fontSize: 17, lineHeight: 1.85, whiteSpace: 'pre-line' }}>
              {t('terms_and_conditions.general_rules')}
            </Typography>

            <Stack divider={<Divider flexItem sx={{ borderColor: publicPalette.border }} />} sx={{ mt: 4 }}>
              {sections.map(([titleKey, bodyKey], index) => (
                <Box component="section" key={titleKey} sx={{ py: index === 0 ? 4 : 5 }}>
                  <Stack direction="row" spacing={2} alignItems="baseline" sx={{ mb: 2 }}>
                    <Typography sx={{ color: publicPalette.primary, fontSize: 12, fontWeight: 900, letterSpacing: '.12em' }}>{String(index + 1).padStart(2, '0')}</Typography>
                    <Typography component="h2" sx={{ color: publicPalette.text, fontSize: { xs: 21, sm: 25 }, fontWeight: 900, letterSpacing: '-.025em' }}>
                      {t(titleKey)}
                    </Typography>
                  </Stack>
                  <Typography sx={{ color: publicPalette.muted, lineHeight: 1.88, whiteSpace: 'pre-line' }}>
                    {t(bodyKey)}
                  </Typography>
                </Box>
              ))}
            </Stack>
          </GlassCard>
        </PublicContainer>
      </Box>
    </PublicPage>
  );
};

export default TermsConditions;
